import React, { useEffect } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';

interface SpecialMessagePopupProps {
  message: string;
  onDismiss: () => void;
  duration?: number; // Optional duration in milliseconds
}

const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const MessageText = styled(motion.div)`
  color: rgba(255, 255, 255, 1);
  font-family: 'Fjalla One', sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0%;
  text-shadow: 0 0 5px rgba(0, 0, 0, 1);
`;

const SpecialMessagePopup: React.FC<SpecialMessagePopupProps> = ({ message, onDismiss, duration = 2500 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onDismiss();
    }, duration); // Use the passed duration or default to 2500ms

    return () => clearTimeout(timer);
  }, [onDismiss, duration]);

  return (
    <AnimatePresence>
      {message && (
        <ModalOverlay
          key="specialMessageOverlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <MessageText
            key="specialMessage"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
          >
            {message}
          </MessageText>
        </ModalOverlay>
      )}
    </AnimatePresence>
  );
};

export default SpecialMessagePopup;
